module.exports = {"noMoreShowButton":"Don't show anymore"}